import { buildFilterSearchPayload } from "src/business/queryBuilder/utils/buildFilterSearchPayload";
import { RtLoaderFn } from "src/components/ReactiveTable/RtLoader";
import { RtResponse } from "src/components/ReactiveTable/RtResponse";

import { ZSpecification } from "../specification";
import { searchCatalogCards } from "./apiRecords";
import { CatalogRecordFilters, ZCatalogRecord } from "./ZCatalogRecord";
import {
  makeCatalogRecordSafe,
  ZCatalogRecordSafe,
} from "./ZCatalogRecordSafe";

export const recordsLoader =
  (
    catalogId: string,
    schemes: ZSpecification[],
  ): RtLoaderFn<ZCatalogRecordSafe, CatalogRecordFilters> =>
  async (request) => {
    const body = {
      classifierId: request.filters?.classifierId,
      classId: request.filters?.classId,
      query: request.filters?.query,
      ...buildFilterSearchPayload(request),
    };
    const resp = await searchCatalogCards(catalogId, body);

    // На сервере баги. Приходят битые данные, которые блокируют работу. Попробуем с этим как-то бороться
    // TODO: Желательно позже убрать
    try {
      const tmp = resp.rows as ZCatalogRecord[];
      tmp.forEach((rec) => {
        rec.classification.forEach((cls) => {
          cls.classes.forEach((it) => {
            if (!it.label) {
              // eslint-disable-next-line no-param-reassign
              it.label = it.id;
            }
          });
        });
      });
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
    }

    return {
      // Тут есть возможность для оптимизации.
      // т.к. внутри makeCatalogRecordSafe каждый раз вызывается makeAttrMetaMap для каждой схемы
      // Можно было бы где-то заранее высчитать makeAttrMetaMap для схем.
      // Но код станет сложнее, а выгода пока не очевидна.
      rows: resp.rows.map((unsafeRow) =>
        makeCatalogRecordSafe(unsafeRow, schemes),
      ),
      totalRows: resp.totalRows,
    } satisfies RtResponse<ZCatalogRecordSafe>;
  };
